export const perfiles = {
    estudiante: 'ESTUDIANTE',
    graduado: 'GRADUADO',
    fake: 'fake'
};